module.exports = __webpack_public_path__ + "media/styles/images/svg/play-overlay-white-b453d4d97769ba555f37be3b17e37faf.svg";